<template>
  <div>
    <h1>Enter the Application Password</h1>
    <input type="password" v-model="password" />
    <input type="button" value="Unlock" @click="unlock()" />
    <div class="integration-error" v-if="integrationError">{{ integrationError }}</div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'

  export default {
    data: function () {
      return {
        password: ''
      }
    },
    computed: mapGetters(['integrationError']),
    methods: {
      unlock: function () {
        this.$store.dispatch('attemptAuthentication', { password: this.password })
        .then(() => {
          this.$router.push('/')
        }, (e) => {
          alert('Authentication Failed!')
        })
      }
    }
  }
</script>
<style lang="less">
  .integration-error {
    padding: 1em;
    margin: 1em;
    border: 1px solid red;
  }
</style>



// WEBPACK FOOTER //
// src/components/UnlockSecret.vue